import { Button } from "@/components/ui/button";

interface QuickAmountButtonsProps {
  onAmountSelect: (amount: string) => void;
}

const QuickAmountButtons = ({ onAmountSelect }: QuickAmountButtonsProps) => {
  return (
    <div className="flex gap-2">
      {["1.5", "5", "10"].map((amount) => (
        <Button 
          key={amount}
          variant="outline" 
          size="sm"
          onClick={() => onAmountSelect(amount)}
        >
          {amount} MATIC
        </Button>
      ))}
    </div>
  );
};

export default QuickAmountButtons;